<template>
  <div class="economize-wrap">
    <div class="btn-content" id="editor">
      <el-button @click="savePdf2">打印pdf</el-button>
    </div>
    <!--startprint-->
    <div class="economize-content" id="render_me">
      <!-- <div class="report-title">节能空间分析报告</div> -->
      <div class="pdf-con" id="imageDom" ref="imageDom">
        <div
          class="contentOne"
          style="
            height: 1060px;
            display: flex;
            flex-flow: column;
            align-items: center;
            justify-content: center;
          "
        >
          <p style="font-size: 30px; text-align: center; font-weight: bold">
            {{ dataAll.cover.title }}
          </p>
          <p style="font-size: 30px; text-align: center; padding: 10px 0px">
            {{ dataAll.cover.subtitle }}
          </p>
          <p style="font-size: 18px; text-align: center">
            {{ dataAll.cover.time }}
          </p>
        </div>
        <div class="content">
          <p class="report-title">1.项目概览</p>
          <table
            class="report-table"
            border="1"
            cellspacing="0"
            cellpadding="0"
          >
            <tr v-if="show">
              <td>项目名称</td>
              <td colspan="8">
                {{ dataAll.descriptionOfProject.projectName }}
              </td>
              <!-- <td colspan="2">报告日期</td>
              <td colspan="3">{{dataAll.descriptionOfProject.reportDate}}</td> -->
            </tr>
            <tr v-if="!show">
              <td>项目名称</td>
              <td colspan="3">
                {{ dataAll.descriptionOfProject.projectName }}
              </td>
              <td colspan="2">报告日期</td>
              <td colspan="3">{{ dataAll.descriptionOfProject.reportDate }}</td>
            </tr>
            <tr>
              <td>总容量</td>
              <td colspan="2">
                {{ dataAll.descriptionOfProject.totalCapacity }}
              </td>
              <td>电压等级</td>
              <td colspan="2">
                {{ dataAll.descriptionOfProject.voltageGrade }}
              </td>
              <td>进线路数</td>
              <td>{{ dataAll.descriptionOfProject.intoTheLineNumber }}</td>
            </tr>
            <tr>
              <td>变压器数量</td>
              <td colspan="3">
                {{ dataAll.descriptionOfProject.numberOfTransformers }}
              </td>
              <td colspan="2">计量方式</td>
              <td colspan="2">
                {{ dataAll.descriptionOfProject.measurementMethods }}
              </td>
            </tr>
            <tr>
              <td>运行方式</td>
              <td colspan="7">{{ dataAll.descriptionOfProject.runWay }}</td>
            </tr>
          </table>
          <table
            style="margin-top: 10px"
            class="report-table"
            border="1"
            cellspacing="0"
            cellpadding="0"
          >
            <tr>
              <td>进线(开关)编号</td>
              <td>变压器编号</td>
              <td>变压器容量</td>
            </tr>
            <tr
              v-for="(item, index) in dataAll.descriptionOfProject
                .transformersList"
              :key="index"
            >
              <td>{{ item.switchName }}</td>
              <td>{{ item.transformerNumber }}</td>
              <td>{{ item.capacity }}</td>
            </tr>
          </table>
          <p class="report-title">2.项目用电总述</p>
          <div
            class="item-content"
            v-html="dataAll.electricityAnOverview"
          ></div>
          <p class="report-title">3.用电特点分析</p>
          <div class="item-content">
            {{ dataAll.electricalCharacteristics.describe }}
          </div>
          <p class="report-title report-title-2">3.1 用电量分析</p>
          <p class="report-title report-title-3">3.1.1 月耗电量</p>
          <div class="item-content">
            {{
              dataAll.electricalCharacteristics.electricityConsumptionAnalysis
                .monthElectricityConsumption.preDescribe
            }}
          </div>
          <div class="echart-content">
            <div id="echartOne" style="width: 100%; height: 100%"></div>
          </div>
        </div>
        <div class="content">
          <div class="item-content">
            {{
              dataAll.electricalCharacteristics.electricityConsumptionAnalysis
                .monthElectricityConsumption.rearDescribe
            }}
          </div>

          <p class="report-title report-title-3">3.1.2 峰平谷耗电量</p>
          <div class="item-content">
            {{
              dataAll.electricalCharacteristics.electricityConsumptionAnalysis
                .peakPingguElectricityConsumption.preDescribe
            }}
          </div>
          <div class="echart-content">
            <div id="echartTwo" style="width: 100%; height: 100%"></div>
          </div>
          <div class="item-content">
            {{
              dataAll.electricalCharacteristics.electricityConsumptionAnalysis
                .peakPingguElectricityConsumption.rearDescribe
            }}
          </div>
          <p class="report-title report-title-2">3.2 电能使用分析</p>
          <p class="report-title report-title-3">3.2.1 功率因数</p>
          <div class="item-content">
            {{
              dataAll.electricalCharacteristics.powerUsageAnalysis.powerFactor
                .preDescribe
            }}
          </div>
        </div>

        <div class="content">
          <div class="echart-content">
            <div id="echartThree" style="width: 100%; height: 100%"></div>
          </div>
        </div>

        <div class="content">
          <div class="item-content">
            {{
              dataAll.electricalCharacteristics.powerUsageAnalysis.powerFactor
                .rearDescribe
            }}
          </div>
          <p class="report-title report-title-3">3.2.2 变压器负载率</p>
          <div class="item-content">
            {{
              dataAll.electricalCharacteristics.powerUsageAnalysis
                .transformerLoadRatio.preDescribe
            }}
          </div>
          <div class="echart-content">
            <div id="echartFour" style="width: 100%; height: 100%"></div>
          </div>
          <div class="item-content">
            {{
              dataAll.electricalCharacteristics.powerUsageAnalysis
                .transformerLoadRatio.rearDescribe
            }}
          </div>
        </div>
        <div class="content">
          <p class="report-title report-title-3">3.2.3三相不平衡</p>
          <div class="item-content">
            {{
              dataAll.electricalCharacteristics.powerUsageAnalysis
                .voltageImbalance.preDescribe
            }}
          </div>
          <div class="echart-content">
            <div id="echartFive" style="width: 100%; height: 100%"></div>
          </div>

          <div class="item-content">
            {{
              dataAll.electricalCharacteristics.powerUsageAnalysis
                .voltageImbalance.rearDescribe
            }}
          </div>
          <p class="report-title report-title-3">3.3 日负荷特性分析</p>
          <div
            class="item-content"
            v-html="
              dataAll.electricalCharacteristics.loadCharacteristicAnalysis
                .preDescribe
            "
          ></div>
        </div>
        <div class="content">
          <div class="echart-content">
            <div id="echartSix" style="width: 100%; height: 100%"></div>
          </div>
          <div class="item-content">
            {{ dataAll.electricalCharacteristics.rearDescribe }}
          </div>
          <p class="report-title">4、 月运行状况评价及建议</p>
          <div class="item-content">
            {{ dataAll.evaluationAndRecommendation.preDescribe }}
          </div>
          <div class="item-content">
            <table
              class="report-table"
              border="1"
              cellspacing="0"
              cellpadding="0"
            >
              <tr>
                <td>指标</td>
                <td>标准值</td>
                <td>当前值</td>
                <td>备注（引用法规或标准）</td>
              </tr>
              <tr
                v-for="(item, index) in dataAll.evaluationAndRecommendation
                  .evaluationTable"
                :key="index"
              >
                <td>{{ item.indicators }}</td>
                <td>{{ item.standard }}</td>
                <td>{{ item.currentValue }}</td>
                <td>{{ item.remark }}</td>
              </tr>
            </table>
          </div>
          <div
            class="item-content"
            v-html="dataAll.evaluationAndRecommendation.rearDescribe"
          ></div>
        </div>
      </div>
    </div>
    <!--endprint-->
  </div>
</template>

<script>
import html2Canvas from "html2canvas";
import * as jsPDF from "jspdf";
import { handleWindowPrint } from "./print";

export default {
  props: {
    data: {
      type: String,
      default: () => {},
    },
    downLoadName: {
      type: String,
      default: () => {},
    },
    show: {
      type: Boolean,
      default: () => {},
    },
  },
  watch: {
    data(e) {
      this.dataAll = JSON.parse(this.data);
      console.log(this.dataAll, 'this.dataAll');
    },
  },
  data() {
    return {
      dataAll: {},
      echartOne: null,
      echartTwo: null,
      echartThree: null,
      echartFour: null,
      echartFive: null,
      echartSix: null,
      Name: "",
    };
  },
  created() {
    console.log(this.show);
    console.log(this.downLoadName);
    this.Name = this.downLoadName;
    this.dataAll = JSON.parse(this.data);
    console.log(this.dataAll);
    console.log(
      "this.dataAllthis.dataAllthis.dataAllthis.dataAllthis.dataAll",
      this.dataAll.electricalCharacteristics.electricityConsumptionAnalysis
        .monthElectricityConsumption.preDescribe
    );
  },
  mounted() {
    console.log(
      this.dataAll.electricalCharacteristics.powerUsageAnalysis
        .transformerLoadRatio.echarts.unit
    );
    // console.log(
    //   this.electricalCharacteristics.powerUsageAnalysis.voltageImbalance.echarts
    //     .x
    // );
    this.getEchart(
      "echartOne",
      this.echartOne,
      this.dataAll.electricalCharacteristics.electricityConsumptionAnalysis
        .monthElectricityConsumption.echarts.y,
      this.dataAll.electricalCharacteristics.electricityConsumptionAnalysis
        .monthElectricityConsumption.echarts.x,
      this.dataAll.electricalCharacteristics.electricityConsumptionAnalysis
        .monthElectricityConsumption.echarts.title,
      this.dataAll.electricalCharacteristics.electricityConsumptionAnalysis
        .monthElectricityConsumption.echarts.unit,
      this.dataAll.electricalCharacteristics.electricityConsumptionAnalysis
        .monthElectricityConsumption.echarts.title,
      "bar",
      "日期"
    );
    this.getEchart(
      "echartTwo",
      this.echartTwo,
      this.dataAll.electricalCharacteristics.electricityConsumptionAnalysis
        .peakPingguElectricityConsumption.echarts.y,
      this.dataAll.electricalCharacteristics.electricityConsumptionAnalysis
        .peakPingguElectricityConsumption.echarts.x,
      this.dataAll.electricalCharacteristics.electricityConsumptionAnalysis
        .peakPingguElectricityConsumption.echarts.title,
      this.dataAll.electricalCharacteristics.electricityConsumptionAnalysis
        .peakPingguElectricityConsumption.echarts.unit,
      this.dataAll.electricalCharacteristics.electricityConsumptionAnalysis
        .peakPingguElectricityConsumption.echarts.subtitle,
      "line",
      "日期"
    );
    this.getEchart(
      "echartThree",
      this.echartThree,
      this.dataAll.electricalCharacteristics.powerUsageAnalysis.powerFactor
        .echarts.y,
      this.dataAll.electricalCharacteristics.powerUsageAnalysis.powerFactor
        .echarts.x,
      this.dataAll.electricalCharacteristics.powerUsageAnalysis.powerFactor
        .echarts.title,
      this.dataAll.electricalCharacteristics.powerUsageAnalysis.powerFactor
        .echarts.unit,
      this.dataAll.electricalCharacteristics.powerUsageAnalysis.powerFactor
        .echarts.subtitle,
      "line",
      "日期"
    );
    this.getEchart(
      "echartFour",
      this.echartFour,
      this.dataAll.electricalCharacteristics.powerUsageAnalysis
        .transformerLoadRatio.echarts.y,
      this.dataAll.electricalCharacteristics.powerUsageAnalysis
        .transformerLoadRatio.echarts.x,
      this.dataAll.electricalCharacteristics.powerUsageAnalysis
        .transformerLoadRatio.echarts.title,
      this.dataAll.electricalCharacteristics.powerUsageAnalysis
        .transformerLoadRatio.echarts.unit,
      this.dataAll.electricalCharacteristics.powerUsageAnalysis
        .transformerLoadRatio.echarts.subtitle,
      "bar",
      "%"
    );
    this.getEchart(
      "echartFive",
      this.echartFive,
      this.dataAll.electricalCharacteristics.powerUsageAnalysis.voltageImbalance
        .echarts.y,
      this.dataAll.electricalCharacteristics.powerUsageAnalysis.voltageImbalance
        .echarts.x,
      this.dataAll.electricalCharacteristics.powerUsageAnalysis.voltageImbalance
        .echarts.title,
      this.dataAll.electricalCharacteristics.powerUsageAnalysis.voltageImbalance
        .echarts.unit,
      this.dataAll.electricalCharacteristics.powerUsageAnalysis.voltageImbalance
        .echarts.subtitle,
      "bar",
      "日期"
    );
    console.log(
      this.dataAll.electricalCharacteristics.loadCharacteristicAnalysis.echarts
        .unit
    );
    this.getEchart(
      "echartSix",
      this.echartSix,
      this.dataAll.electricalCharacteristics.loadCharacteristicAnalysis.echarts
        .y,
      this.dataAll.electricalCharacteristics.loadCharacteristicAnalysis.echarts
        .x,
      this.dataAll.electricalCharacteristics.loadCharacteristicAnalysis.echarts
        .title,
      this.dataAll.electricalCharacteristics.loadCharacteristicAnalysis.echarts
        .unit,
      this.dataAll.electricalCharacteristics.loadCharacteristicAnalysis.echarts
        .subtitle,
      "line",
      "日期"
    );
  },
  methods: {
    getEchart(id, chartName, data, xdata, title, unit, legend, type, xname) {
      // console.log(legend);
      // if(legend instanceof Array)
      // console.log(legend instanceof Array);
      let legendtitle = legend;
      if (legendtitle instanceof Array) {
        legendtitle = legend;
        // console.log(legendtitle);
      } else {
        legendtitle = [legend];
        // legendtitle.push(legend);
        // console.log(legendtitle);
      }
      // let dataAll = true;
      let dataseries = [];
      let icon = ["diamond", "rect", "triangle", "pin", "arrow"];
      // console.log(typeof data[0]);
      if (typeof data[0] != "string") {
        for (let i = 0; i < data.length; i++) {
          dataseries.push({
            name: legend[i],
            data: data[i],
            type: type,
            symbol: icon[i],
            // legend: icon[i]
          });
        }
        // console.log(dataseries);
      } else {
        dataseries = [
          {
            name: legend,
            data: data,
            type: type,
          },
        ];
        // console.log(dataseries);
        // console.log("222");
      }
      let this_ = this;
      chartName = this.$echarts.init(document.getElementById(id));
      var option = {
        title: {
          text: title,
          left: "center",
        },
        grid: {
          x: 60,
          y: 50,
          x2: 50,
          y2: 60,
          borderWidth: 10,
          width: "70%",
        },
        color: [
          "#d2b533",
          "#fe3c00",
          "#7928cb",
          "#8eb2f0",
          "#003690",
          "#0db198",
          "#9ff093",
        ],
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: legendtitle,
          top: "20%",
          right: "3%",
          orient: "vertical", //垂直显示
          // icon: ["line", "pin", "diamond"]
        },

        // dataZoom: [
        //   {
        //     type: "inside",
        //     show: true,
        //     realtime: true
        //   },
        //   {
        //     show: true,
        //     realtime: true,
        //     end: 100,
        //     type: "slider",
        //     width: "92%",
        //     left: "center"
        //   }
        // ],
        // toolbox: {
        //   show: true,
        //   feature: {
        //     // dataView: { show: true, readOnly: false },
        //     magicType: { show: true, type: ["line", "bar"] },
        //     // restore: { show: true },
        //     saveAsImage: { show: true }
        //   }
        // },
        calculable: true,
        xAxis: [
          {
            type: "category",
            data: xdata,
            name: xname,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: unit,
          },
        ],
        series: dataseries,
      };

      chartName.setOption(option, true);
      if (chartName) {
        window.addEventListener("resize", function () {
          chartName.resize();
        });
      }
    },
    savePdf() {
      let scrollHeight = this.$refs.imageDom.scrollHeight;
      document.querySelector("#imageDom").style.height = scrollHeight + "px";
      console.log(this.Name);
      var title = this.Name;
      html2Canvas(document.querySelector("#imageDom"), {
        allowTaint: true,
        taintTest: false,
        height: this.$refs.imageDom.scrollHeight,
      }).then(function (canvas) {
        // console.log(canvas);
        let contentWidth = canvas.width;
        let contentHeight = canvas.height;
        let pageHeight = (contentWidth / 592.28) * 841.89;
        let leftHeight = contentHeight;
        let position = 0;
        let imgWidth = 595.28;
        let imgHeight = (592.28 / contentWidth) * contentHeight;
        let pageData = canvas.toDataURL("image/jpeg", 1.0);
        let PDF = new jsPDF("", "pt", "a4");
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            if (leftHeight > 800) {
              //leftHeight > 0 &&
              PDF.addPage();
            }
          }
        }
        PDF.save(title + ".pdf");
        document.querySelector("#imageDom").style.height = "calc(100% - 60px)";
      });
    },
    savePdf2() {
      var canvass = document.querySelectorAll("#imageDom canvas");
      var noneCanvasImg = document.querySelectorAll(".none-canvas-img");
      console.log(noneCanvasImg, "触发pdf打印");
      let name = this.Name;
      for (let index = 0; index < noneCanvasImg.length; index++) {
        const element = noneCanvasImg[index];
        // 判断是否是IE
        if (!!window.ActiveXObject || "ActiveXObject" in window) {
          element.removeNode(true);
        } else {
          element.remove();
        }
      }
      let index = 0;

      for (let k4 = 0; k4 < canvass.length; k4++) {
        let imageURL = canvass[k4].toDataURL("image/png");
        let img = document.createElement("img");
        img.src = imageURL;
        img.setAttribute("style", "max-width: 100%;");
        img.setAttribute("index", k4);
        img.className = "isNeedRemove none-canvas-img";
        // canvass[k4].style.display = 'none'
        // canvass[k4].parentNode.style.width = '100%'
        // canvass[k4].parentNode.style.textAlign = 'center'
        img.onload = function (e) {
          index++;
          const imgIndex = e.currentTarget.attributes.index.value;
          canvass[imgIndex].parentNode.insertBefore(
            img,
            canvass[imgIndex].nextElementSibling
          );
          if (index == canvass.length) {
            const style = `.economize-wrap {
                                              min-width: 794px;
                                              margin: 0px auto;
                                              height: 100%;
                                              overflow: hidden;
                                            }
                                            .btn-content {
                                              padding-bottom: 10px;
                                              padding-left: 10px;
                                              padding-right: 10px;
                                              margin-bottom: 10px;
                                              text-align: right;
                                              border-bottom: 1px solid #e4e7ed;
                                            }
                                            .economize-content {
                                              width: 100%;
                                              margin: 0px auto;
                                              height: calc(100% - 60px);
                                              overflow: auto;
                                            }
                                            .pdf-con {
                                              width: 794px;
                                              margin: 0px auto;
                                            }
                                            .report-title {
                                              font-size: 30px;
                                              text-align: center;
                                              line-height: 1110px;
                                            }
                                            .content {
                                              margin-bottom: 10px;
                                              width: calc(100% - 60px);
                                              padding: 30px 30px;
                                            }
                                            .contentOne {
                                              margin-bottom: 10px;
                                              width: calc(100% - 60px);
                                              padding: 30px 30px;
                                            }
                                            .report-table {
                                              width: 100%;
                                            }
                                            
                                            .report-table tr {
                                              height: 30px;
                                              line-height: 30px;
                                            }
                                            
                                            .report-table tr td {
                                              text-align: center;
                                            }
                                            
                                            .report-title {
                                              padding: 10px 0px;
                                              height: 30px;
                                              line-height: 30px;
                                              font-size: 24px;
                                              text-align: left;
                                              font-weight: bold;
                                              margin: 5px;
                                            }
                                            
                                            .report-title-2 {
                                              font-size: 22px;
                                            }
                                            
                                            .report-title-3 {
                                              font-size: 20px;
                                            }
                                            
                                            .item-content {
                                              width: 100%;
                                              text-indent: 30px;
                                              line-height: 30px;
                                            }
                                            
                                            .echart-content {
                                              width: 100%;
                                              height: 300px;
                                            }`;
            console.log(index, "触发pdf打印");
            handleWindowPrint("#imageDom", name, style, this);
          }
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.economize-wrap {
  min-width: 794px;
  margin: 0px auto;
  height: 100%;
  overflow: hidden;
}
.btn-content {
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 10px;
  text-align: right;
  border-bottom: 1px solid #e4e7ed;
}
.economize-content {
  width: 100%;
  margin: 0px auto;
  height: calc(100% - 60px);
  overflow: auto;
  position: absolute;
}
.pdf-con {
  width: 794px;
  margin: 0px auto;
}
.report-title {
  font-size: 30px;
  text-align: center;
  line-height: 1110px;
}
.content {
  margin-bottom: 10px;
  width: calc(100% - 60px);
  // height: 1060px;
  padding: 30px 30px;
  // overflow: hidden;
  border: 1px solid #e4e7ed;
}
.contentOne {
  margin-bottom: 10px;
  width: calc(100% - 60px);
  // height: 1060px;
  padding: 30px 30px;
  // overflow: hidden;
  border: 1px solid #e4e7ed;
}
.report-table {
  width: 100%;
}

.report-table tr {
  height: 30px;
  line-height: 30px;
}

.report-table tr td {
  text-align: center;
}

.report-title {
  padding: 10px 0px;
  height: 30px;
  line-height: 30px;
  font-size: 24px;
  text-align: left;
  font-weight: bold;
  margin: 5px;
}

.report-title-2 {
  font-size: 22px;
}

.report-title-3 {
  font-size: 20px;
}

.item-content {
  text-indent: 30px;
  line-height: 30px;
  text-align: left;
  white-space: normal;
}

.echart-content {
  width: 100%;
  height: 300px;
}
</style>
<style>
@media print {
  .list-content {
    display: none;
  }
  .tab-content {
    display: none;
  }
  .wrap-print {
    display: none;
  }
}
</style>
